export default __webpack_public_path__ + "static/ism-home-mobile1-1e1f88813c23d4f15c7aa6d1a1c7b5c7.png";